import Axios from 'axios';
import { toast } from 'react-toastify';
import React from 'react';
import ReactDOM from 'react-dom';
import CreditTable from "../components/credit-table/CreditTable";

document.addEventListener('trigger-credit-table', function (event) {
    const updateUrl = event.detail.updateUrl;

    if (updateUrl) {
        Axios.get(updateUrl)
            .then(({ data: vehicleData }) => {
                if (vehicleData) {
                    const { enrichedValues, price, type} = vehicleData;
                    const creditTableData = {
                        price: price || '',
                        finance: enrichedValues?.finance,
                        finance_deposit: enrichedValues?.finance_deposit,
                        finance_duration: enrichedValues?.finance_duration,
                        finance_credit: enrichedValues?.finance_credit,
                        finance_totalprice: enrichedValues?.finance_totalprice,
                        finance_finalterm: enrichedValues?.finance_finalterm
                    };

                    renderCreditTable(creditTableData, vehicleData, type);
                }
            })
            .catch((error) => {
                toast.error('Er is iets verkeerd gegaan, probeer het nogmaals.');
                throw new Error(error);
            });
    }
});

function renderCreditTable(creditTableData, vehicleData, subtitle) {
    ReactDOM.render(
        <CreditTable
            name={subtitle}
            openByDefault={true}
            vehicleData={vehicleData}
            creditTableData={creditTableData}
        />,
        document.getElementById('creditTableContainer')
    );
}
